/**
 * @fileoverview Hook de UI Layer para manejar el estado de botones deshabilitados de forma genérica.
 * @module ui/useButtonsDisabled
 * @category Hook - UI Layer
 * @since 1.0.0
 * @version 1.0.0
 */
import { useState, useCallback } from 'react';

/**
 * Hook genérico para manejar el estado de botones deshabilitados.
 * @returns {{ buttonsDisabled: boolean, setButtonsDisabled: function, disableButtons: function }}
 */
export function useButtonsDisabled() {
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const disableButtons = useCallback(() => setButtonsDisabled(true), []);
  return { buttonsDisabled, setButtonsDisabled, disableButtons };
}
